var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layerTree"},[_c('span',{staticClass:"layerTittle"},[_vm._v("出让时间安排")]),_c('el-tree',{attrs:{"data":_vm.treeNode,"show-checkbox":"","node-key":"id","default-checked-keys":_vm.checkedKeys,"props":_vm.defaultProps},on:{"check":_vm.nodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }